import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String,
    hoverable: { type: Boolean, default: true },
    striped: { type: Boolean, default: false },
  };

  connect() {
    this.applyStyles();
  }

  applyStyles() {
    if (this.stripedValue) {
      this.element.classList.add("table-striped");
    }
  }
}
